var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain contactus"},[_c('Banner',{ref:"cBanner",attrs:{"banner_img":_vm.resBanners,"banner_en":"CONTACT US","banner_cn":"联系我们"}}),_c('Contactus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }